import Module from '../utils/Module'
import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class VideoModule extends Module {
  constructor (options) {
    super(options)

    this.DOMEl = options.element;
    this.content = this.DOMEl.querySelector(".video__wrapper");


    this.init()
  }

  init () {
    ScrollTrigger.create({
      trigger: this.DOMEl,
      start: "top center+=100",
      onEnter: ()=>{
        gsap.to(this.content, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"});
      },
      onEnterBack: ()=>{
        gsap.to(this.content, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"});
      }
    });
  }
}
